import { GLTFData } from 'scripts/animations/three/types/gltf';
import { useGLTF } from '@react-three/drei';
import { BarMaterial, GlassMaterial, PrimaryMaterial } from './common/materials';

import ModelUrl from 'assets/gl/home/experiences/quality.glb?url';
import { useThree } from '@react-three/fiber';
import { useLayoutEffect } from 'react';
import { createRoomEnv } from 'scripts/animations/three/helpers/room';

type Props = {
    final?: boolean;
    useEnvMap?: boolean;
};

type QualityGLTF = GLTFData<
    'diamond'
    | 'base'
    | 'edge'
    | 'setting'
    | 'front_glass'
    | 'body_1'
    | 'dot_1'
    | 'dot_0'
    | 'check'
    | 'line_3'
    | 'line_2'
    | 'line_3'
    | 'line_1'
    | 'body_2'
    | 'dot_1_1'
    | 'dot_0_1'
    | 'check_1'
    | 'line_3_1'
    | 'line_2_1'
    | 'line_1_1'
>;

export const Quality = (props: Props) => {
    const { nodes } = useGLTF(ModelUrl) as QualityGLTF;
    const { final, useEnvMap } = props;

    const renderer = useThree(state => state.gl);

    useLayoutEffect(() => {
        const environment = useEnvMap ? createRoomEnv(renderer) : null;
        GlassMaterial.envMap = environment;
    }, [renderer, useEnvMap]);

    return (
        <group name="Quality_-_selection_of_playlists" position={[0, 0, -0.1]}>
            <group name="Quality_-_selection_of_playlists_2" position={[0, -0.03, 0.1]} scale={final ? 1 : 0}>
                <mesh
                    name="diamond"
                    geometry={nodes.diamond.geometry}
                    material={BarMaterial}
                    castShadow
                    receiveShadow
                    position={[0.08, 0.16, 0.12]}
                    rotation={[0.06, -0.31, -0.37]}
                    scale={1}
                />
                <group name="glass" position={[-0.07, -0.02, -0.01]} rotation={[0.2, 0.18, 0.22]} scale={1}>
                    <mesh
                        name="base"
                        geometry={nodes.base.geometry}
                        material={PrimaryMaterial}
                        castShadow
                        receiveShadow
                        position={[-0.05, -0.05, 0]}
                        rotation={[Math.PI, 0, -2.36]}
                        scale={1}
                    />
                    <mesh
                        name="edge"
                        geometry={nodes.edge.geometry}
                        material={PrimaryMaterial}
                        castShadow
                        receiveShadow
                        position={[0.03, 0.03, 0]}
                        rotation={[-Math.PI / 2, -Math.PI / 4, Math.PI]}
                        scale={1}
                    />
                    <mesh
                        name="setting"
                        geometry={nodes.setting.geometry}
                        material={BarMaterial}
                        castShadow
                        receiveShadow
                        position={[-0.01, -0.01, 0]}
                        rotation={[-Math.PI / 2, -Math.PI / 4, -Math.PI / 2]}
                        scale={1}
                    />
                    <mesh
                        name="front_glass"
                        geometry={nodes.front_glass.geometry}
                        material={GlassMaterial}
                        castShadow
                        receiveShadow
                        position={[0.03, 0.03, 0]}
                        rotation={[Math.PI / 2, -Math.PI / 4, 0]}
                        scale={1}
                    />
                </group>
                <group name="14_list_icon_2" position={[0.05, 0.03, 0.03]} rotation={[-2.92, 0, 3.01]} scale={1}>
                    <mesh
                        name="body_1"
                        geometry={nodes.body_1.geometry}
                        material={PrimaryMaterial}
                        castShadow
                        receiveShadow
                        position={[0.02, 0, -0.01]}
                        rotation={[0, -1.57, 0]}
                        scale={[0.09, 1, 1.44]}
                    />
                    <group name="dots" position={[-0.03, -0.02, 0.01]} rotation={[-Math.PI / 2, 0, -Math.PI / 2]}>
                        <mesh
                            name="dot_1"
                            geometry={nodes.dot_1.geometry}
                            material={BarMaterial}
                            castShadow
                            receiveShadow
                            position={[0, 0, -0.02]}
                            rotation={[0, 0, -Math.PI / 2]}
                            scale={[0.38, 0.05, 0.38]}
                        />
                        <mesh
                            name="dot_0"
                            geometry={nodes.dot_0.geometry}
                            material={BarMaterial}
                            castShadow
                            receiveShadow
                            position={[0, 0, 0.02]}
                            rotation={[0, 0, -Math.PI / 2]}
                            scale={[0.38, 0.05, 0.38]}
                        />
                    </group>
                    <mesh
                        name="check"
                        geometry={nodes.check.geometry}
                        material={BarMaterial}
                        castShadow
                        receiveShadow
                        position={[-0.03, 0.05, 0.01]}
                        rotation={[0, -1.57, 0]}
                        scale={1}
                    />
                    <mesh
                        name="line_3"
                        geometry={nodes.line_3.geometry}
                        material={BarMaterial}
                        castShadow
                        receiveShadow
                        position={[0.03, -0.05, 0]}
                        rotation={[0, -1.57, 0]}
                        scale={1}
                    />
                    <mesh
                        name="line_2"
                        geometry={nodes.line_2.geometry}
                        material={BarMaterial}
                        castShadow
                        receiveShadow
                        position={[0.03, 0, 0]}
                        rotation={[0, -1.57, 0]}
                        scale={1}
                    />
                    <mesh
                        name="line_1"
                        geometry={nodes.line_1.geometry}
                        material={BarMaterial}
                        castShadow
                        receiveShadow
                        position={[0.03, 0.04, 0]}
                        rotation={[0, -1.57, 0]}
                        scale={1}
                    />
                </group>
                <group name="14_list_icon_2_1" position={[-0.02, 0.07, 0.09]} rotation={[3.12, 0, 2.66]} scale={1}>
                    <mesh
                        name="body_2"
                        geometry={nodes.body_2.geometry}
                        material={PrimaryMaterial}
                        castShadow
                        receiveShadow
                        position={[0.02, 0, -0.01]}
                        rotation={[0, -1.57, 0]}
                        scale={[0.09, 1, 1.44]}
                    />
                    <group name="dots_1" position={[-0.03, -0.02, 0.01]} rotation={[-Math.PI / 2, 0, -Math.PI / 2]}>
                        <mesh
                            name="dot_1_1"
                            geometry={nodes.dot_1_1.geometry}
                            material={BarMaterial}
                            castShadow
                            receiveShadow
                            position={[0, 0, -0.02]}
                            rotation={[0, 0, -Math.PI / 2]}
                            scale={[0.38, 0.05, 0.38]}
                        />
                        <mesh
                            name="dot_0_1"
                            geometry={nodes.dot_0_1.geometry}
                            material={BarMaterial}
                            castShadow
                            receiveShadow
                            position={[0, 0, 0.02]}
                            rotation={[0, 0, -Math.PI / 2]}
                            scale={[0.38, 0.05, 0.38]}
                        />
                    </group>
                    <mesh
                        name="check_1"
                        geometry={nodes.check_1.geometry}
                        material={BarMaterial}
                        castShadow
                        receiveShadow
                        position={[-0.03, 0.05, 0.01]}
                        rotation={[0, -1.57, 0]}
                        scale={1}
                    />
                    <mesh
                        name="line_3_1"
                        geometry={nodes.line_3_1.geometry}
                        material={BarMaterial}
                        castShadow
                        receiveShadow
                        position={[0.03, -0.05, 0]}
                        rotation={[0, -1.57, 0]}
                        scale={1}
                    />
                    <mesh
                        name="line_2_1"
                        geometry={nodes.line_2_1.geometry}
                        material={BarMaterial}
                        castShadow
                        receiveShadow
                        position={[0.03, 0, 0]}
                        rotation={[0, -1.57, 0]}
                        scale={1}
                    />
                    <mesh
                        name="line_1_1"
                        geometry={nodes.line_1_1.geometry}
                        material={BarMaterial}
                        castShadow
                        receiveShadow
                        position={[0.03, 0.04, 0]}
                        rotation={[0, -1.57, 0]}
                        scale={1}
                    />
                </group>
            </group>
        </group>
    );
};
